export default __webpack_public_path__ + "static/media/summary.fd7c40f4.svg";